import $ from 'jquery';
import plugin from '@core/plugins/lib';

export const ELEMENT_SELECTOR = '[data-colour-list]';
export const PLUGIN_NAME = 'ColourList';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(/* webpackChunkName: "colour-list" */ './colour-list'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/colour-list/index.js